import { FIELD_TYPE, FORMAT_TIME } from "types/enums";
import { DataFormField } from "types/models/input-field-type";
import { ColumnsEdit } from "../../../../../../types/models/column-table-edit";
import dayjs from "dayjs";
import { validatePhoneNumber } from "pages/AdministrativePersonnel/HumanResourcesManagement/CandidateDirectory/Tab/FormAdd/config";
const {
  INPUT,
  DATE,
  SELECT,
  DATE_DISABLE_NO_DAY,
  COMBO_BOX,
  AUTO_COMPLETE,
  CURRENCY,
  NUMBER,
  DATE_DISABLE,
  DATE_PRE,
  DATE_DAY_INPUT,
  TEXT_AREA,
} = FIELD_TYPE;
const validatePositiveInteger = (_, value) => {
  if (!value || /^[1-9]\d*$/.test(value)) {
    return Promise.resolve();
  }
  return Promise.reject(new Error("Chưa nhập đúng định dạng!"));
};
const listMonths = [];
for (let month = 1; month <= 12; month++) {
  listMonths.push({
    value: month,
    label: `Tháng ${month}`,
  });
}

//--------------------------------------------------------
const listYears = [];
const currentYear = new Date().getFullYear();
const startYear = 2020;
const endYear = currentYear + 100;
for (let year = startYear; year <= endYear; year++) {
  listYears.push({
    value: year,
    label: year.toString(),
  });
}
const css = { xs: 24, sm: 24, md: 24, lg: 8, xl: 8 };

const dataFields: DataFormField[] = [
  {
    type: COMBO_BOX,
    label: "Role",
    name: "role",
    rules: [{ required: true, message: "Chưa nhập quyền" }],
    css: css,
    wrapperCol: { xs: 24, sm: 14, md: 14, lg: 14, xl: 14 },
    labelCol: { xs: 24, sm: 10, md: 10, lg: 10, xl: 10 },
  },
  {
    type: SELECT,
    label: "Mã quyền duyệt",
    name: "id_quyen_duyet",
    rules: [{ required: true, message: "Chưa nhập quyền duyệt" }],
    css: css,
    wrapperCol: { xs: 24, sm: 14, md: 14, lg: 14, xl: 14 },
    labelCol: { xs: 24, sm: 10, md: 10, lg: 10, xl: 10 },
  },
  {
    type: TEXT_AREA,
    label: "Ghi chú",
    name: "ghi_chu",
    css: css,
    wrapperCol: { xs: 24, sm: 14, md: 14, lg: 14, xl: 14 },
    labelCol: { xs: 24, sm: 10, md: 10, lg: 10, xl: 10 },
  },
  {
    type: DATE_DISABLE_NO_DAY,
    label: "Thời gian áp dụng từ",
    name: "ngay_hieu_luc",
    expand: true,
    optionsTime: { showTime: true, format: FORMAT_TIME.dateTime_2 },
    disableDate: false,
    rules: [
      {
        required: true,
        message: "Bắt buộc phải chọn thời gian áp dụng từ",
      },
    ],
    css: css,
    wrapperCol: { xs: 24, sm: 14, md: 14, lg: 12, xl: 12 },
    labelCol: { xs: 24, sm: 10, md: 10, lg: 12, xl: 12 },
  },
  {
    type: DATE_DISABLE_NO_DAY,
    label: "Thời gian áp dụng đến",
    name: "ngay_het_hieu_luc",
    expand: true,
    optionsTime: { showTime: true, format: FORMAT_TIME.dateTime_2 },
    disableDate: false,
    css: css,
    wrapperCol: { xs: 24, sm: 14, md: 14, lg: 12, xl: 12 },
    labelCol: { xs: 24, sm: 10, md: 10, lg: 12, xl: 12 },
  },
  {
    type: SELECT,
    label: "Trạng thái sử dụng",
    name: "trang_thai",
    css: css,
    rules: [
      {
        required: true,
        message: "Bắt buộc phải chọn trạng thái",
      },
    ],
    wrapperCol: { xs: 24, sm: 14, md: 14, lg: 14, xl: 14 },
    labelCol: { xs: 24, sm: 10, md: 10, lg: 10, xl: 10 },
    options: [
      { value: 1, label: "Còn sử dụng" },
      { value: 0, label: "Không sử dụng" },
    ],
  },
];

export { dataFields };
